import DotIndicator from "../../../../../ui/dotindicator/dotindicator";
import "./tab0.scss";
import HalfAccordionCard from "../../../../../ui/halfcoloraccordion/halfcoloraccordion";

const Tab0 = () => {
    return (
        <div className="Tab0">
            <div className="row">
                <div className="d-flex align-items-center mb-4">
                    <DotIndicator/>
                    <span>تعرفه تبلیغات در گوگل</span>
                </div>
                <p style={{marginTop: '-13px'}} className="font-light gray-text">این متن برای توضیحات مربوط به دانلود اپلیکیشن است که کاربر را راهنمایی کند.</p>
                <HalfAccordionCard />
            </div>
        </div>
    );
}

export default Tab0;